import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white dark:bg-dark-900">
      <div className="flex flex-col items-center space-y-4">
        <div className="w-16 h-16 border-4 border-dashed rounded-full animate-spin border-primary-500 dark:border-primary-400"></div>
        <p className="text-lg text-gray-600 dark:text-gray-300 font-medium">Duke ngarkuar...</p>
      </div>
    </div>
  );
};

export default LoadingSpinner;
